window.QuotationManager = (element, fields, urls) => {
  import('./QuotationManager').then(({ default: QuotationManager }) => {
    new QuotationManager(element, fields, urls);
  });
};
